<template>
  <div class="bc-sched">
    <div class="bc-sched__inner">
      <h1 class="bc-sched__title">{{ $T('官网资料页标题') }}</h1>
      <p class="bc-sched__desc">{{ $T('官网资料页说明') }}</p>
      <ul class="bc-sched__list">
        <li v-for="doc in docs" :key="doc.id" class="bc-sched__item">
          <div class="bc-sched__meta">
            <h2 class="bc-sched__name">{{ $T(doc.titleKey) }}</h2>
            <p class="bc-sched__file">{{ doc.fileName }}</p>
          </div>
          <a
            class="bc-sched__btn"
            :href="doc.url"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ $T('官网资料查看下载') }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { BC_SCHEDULE_DOCS } from './bcScheduleDocs';

export default {
  name: 'ScheduleDocs',
  data() {
    return {
      docs: BC_SCHEDULE_DOCS,
    };
  },
  mounted() {
    document.title = this.$T('官网资料页标题');
  },
};
</script>

<style lang="scss" scoped>
.bc-sched {
  background: #f3f4f6;
  min-height: 50vh;
  padding: 48px 24px 80px;
}
.bc-sched__inner {
  max-width: 720px;
  margin: 0 auto;
}
.bc-sched__title {
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 700;
  color: #1e2842;
  text-align: center;
}
.bc-sched__desc {
  margin: 0 0 32px;
  font-size: 15px;
  line-height: 1.6;
  color: #5b6478;
  text-align: center;
}
.bc-sched__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.bc-sched__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #fff;
  border-radius: 12px;
  padding: 18px 20px;
  box-shadow: 0 6px 20px rgba(30, 40, 66, 0.06);
}
.bc-sched__name {
  margin: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  color: #1e2842;
  line-height: 1.35;
}
.bc-sched__file {
  margin: 0;
  font-size: 12px;
  color: #9ca3af;
  word-break: break-all;
}
.bc-sched__btn {
  flex-shrink: 0;
  display: inline-block;
  padding: 10px 18px;
  border-radius: 8px;
  background: #1e2842;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;
}
.bc-sched__btn:hover {
  background: #0f172a;
  color: #fff;
}

@media (max-width: 640px) {
  .bc-sched {
    padding: 32px 16px 64px;
  }
  .bc-sched__title {
    font-size: 22px;
  }
  .bc-sched__item {
    flex-direction: column;
    align-items: flex-start;
  }
  .bc-sched__btn {
    width: 100%;
    text-align: center;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// ScheduleDocs.vue?5fb2c8f6